import { PermissionField } from '../Common/permissions';
import { useSelectedBusiness } from './useSelectedBusiness';

export const usePermission = (field: PermissionField): boolean => {
  const business = useSelectedBusiness();

  return business.administrator || business.userRole[field];
};
